import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getPatientCgmOrdersRequest = (query, params) =>
  restRequest({
    uri: 'patientCgmOrders',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const addCgmOrder = (body, params) =>
  restRequest({
    uri: 'patientCgmOrders',
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const updateCgmOrder = (id, body, params) =>
  restRequest({
    uri: `patientCgmOrders/${id}`,
    method: HttpMethods.Put,
    body,
    ...params,
  });
